import { Component, OnInit, Input, Output,EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import{correoService, LoopBackAuth, validacionService, archivosCompartidosService} from '../services/api-rest.service';
import { ToastrService } from 'ngx-toastr';
import{MessageService} from '../services/message.service';

@Component({
  selector: 'form-envio-mail',
  template: `
  
    <div class="form-group">
      <input 
        type="text" 
        class="form-control" 
        disabled="disabled" 
        value="{{mail.de.nombre + ' '+ mail.de.apellido}}">   
    </div>
    <div class="form-group">
      <div 
        class="input-para" 
        (dblclick)="!esEstudiante ? emittAgregarUsuario.emit('para') :''">
          <div 
            class="placeholder" 
            (click)="!esEstudiante ? emittAgregarUsuario.emit('para') :''"
            [ngClass]="{'link-para': !esEstudiante}"> Para </div>
          <div 
            class="opciones" 
            *ngFor="let item of mail.para" 
            (mouseover)="item.activo = true" 
            (mouseleave)="item.activo = false"> 

            {{item.apellido + item.nombre | slice:0:25}}
            <span 
              class="deselect-option card-puntero" 
              (click)="eliminarAgregarUsuario(item, 'para')"
              [ngStyle]="{'visibility': esEstudiante ? 'hidden':'visible'}"> ✕ </span>
            <div class="letrero" *ngIf="item.activo"> 
              <div class="contenido">
                  <h1>{{item.apellido + item.nombre}}</h1>
                  <h2>{{item.correo_electronico}}</h2>
              </div>  
            </div>
          </div>
      </div>
    </div>
    <!-- Copia Oculta -->
    <div class="form-group">
      <div 
        class="input-para" 
        (dblclick)="!esEstudiante ? emittAgregarUsuario.emit('cc') :''">
          <div 
            class="placeholder" 
            (click)="!esEstudiante ? emittAgregarUsuario.emit('cc') :''"
            [ngClass]="{'link-para': !esEstudiante}"> CCO </div>
          <div 
            class="opciones" 
            *ngFor="let item of mail.cc" 
            (mouseover)="item.activo = true" 
            (mouseleave)="item.activo = false"> 

            {{item.apellido + item.nombre | slice:0:25}}
            <span 
              class="deselect-option card-puntero" 
              (click)="eliminarAgregarUsuario(item, 'cc')"
              [ngStyle]="{'visibility': esEstudiante ? 'hidden':'visible'}"> ✕ </span>
            <div class="letrero" *ngIf="item.activo"> 
              <div class="contenido">
                  <h1>{{item.apellido + item.nombre}}</h1>
                  <h2>{{item.correo_electronico}}</h2>
              </div>  
            </div>
          </div>
      </div>
    </div>
   
    <div class="form-group">
      <input 
        type="text" 
        class="form-control" 
        placeholder="Agregar Asunto"
        [(ngModel)] ="mail.asunto">
    </div>
    
    <adjuntar-archivos-mensaje [archivos]="archivosAdjuntar"></adjuntar-archivos-mensaje>
    <app-ngx-editor [config]="editorConfig" [(ngModel)] ="mail.mensaje"></app-ngx-editor>
    <div class="row d-flex justify-content-between mt-2">
      <div class="col-md-4 d-flex align-items-start">
          <button  class="btn btn-primary" title="Enviar" (click)="enviar()"> 
            <i class="icofont icofont-paper-plane"></i>  Enviar
          </button>
          <label id="#archivo" class="btn btn-white">
            <i class="ti-clip"></i> Adjuntar
          <input
            id="archivo"
            type="file"
            style="display:none"
            (change)="adjuntarArchivos($event)" />
        </label>
          
      </div>
     
      <div class="col-md-5">
          <button  class="btn btn-danger btn-circulo" title="Eliminar" (click)="emittEliminar.emit(mail)" >
            <i class="icofont icofont-ui-delete m-0"></i> Descartar
          </button>
          <button 
            type="button"
            (click)="guardar()"
            class="btn btn-primary btn-xs waves-effect waves-light" 
            title="Guardar">
              <i class="far fa-save" m-0></i> Guardar
          </button>
      </div>
    </div>
  
  `,
  providers:[LoopBackAuth, correoService,MessageService, validacionService, archivosCompartidosService]
})
export class FormEnvioMailComponent implements OnInit {
  @Input() mail:any
  @Input() spinner:any
  @Input() esEstudiante: boolean = false
  @Output() emittRefrescar= new EventEmitter()
  @Output() emittAgregarUsuario = new EventEmitter()
  @Output() emittEliminar = new EventEmitter()

  
  /** Variables */
  editorConfig:any
  public archivosAdjuntar:any[] =[]
  public extenciones:any[]
  constructor(
    private correoService:correoService,
    private val: validacionService,
    private archivosCompartidosService:archivosCompartidosService,
    private toastr: ToastrService,
    ) { }

  ngOnInit() {
    this.archivosAdjuntar =[]
    this.editorConfig = {
      "height": "200px",
      "placeholder": "'Redacte su correo'",
      "imageEndPoint": "http://myApiEndPoint",
      "toolbar": [
        ["bold", "italic", "underline", "superscript", "subscript"],
        ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull", "indent", "outdent"],,
        [ "horizontalLine", "orderedList", "unorderedList"],
        ["link", "unlink"] ]
    }
    this.getExtencion()
    if(this.mail.glb_correo_mensaje_principal_id != undefined) this.getArchivos()
  }

  ngOnChanges(changes:SimpleChanges) {
    if( changes.mail!= undefined 
        && changes.mail.currentValue != undefined 
        && changes.mail.currentValue.id == null)
        this.archivosAdjuntar =[]
  }

  public eliminarAgregarUsuario(item:any, tipo: string){
    if(!this.esEstudiante){
      if(tipo =='para'){
        let index = this.mail.para.findIndex((x:any)=> x.glb_usuario_id == item.glb_usuario_id)
        this.mail.para.splice(index,1)
      }
      
      if(tipo =='cc'){
        let index = this.mail.cc.findIndex((x:any)=> x.glb_usuario_id == item.glb_usuario_id)
        this.mail.cc.splice(index,1)
      }
    }
  }

  private getArchivos(){
    this.correoService.archivosAdjuntos(parseInt(this.mail.glb_correo_mensaje_principal_id)).subscribe(
        result=>{
            this.archivosAdjuntar = result.map((x:any)=>{
                return {
                    id:x.id,
                    name: x.nombre,
                    type: x.extension,
                    size: x.tamanio,
                    siglas: 'MB',
                    tamanio: x.tamanio,
                    fecha: '',
                    estado:1,
                    archivo: null
                }
            })
            console.log("archivos add -->", this.archivosAdjuntar)
        }
    )
}
private getExtencion(){
  this.archivosCompartidosService.extencionesArchivos().subscribe(
      result=>{
          this.extenciones = result
      }
  )
}
  public adjuntarArchivos(event:any){
    let files = event.target.files;
      if (files) {
        for (let file of files) {
          let reader = new FileReader();
          let tamanio = this.val.sizeArchivo(file.size)
          let type = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2)
          let extension = this.extenciones.find((x:any)=>x.extension == type)
          if(extension == undefined){
            this.toastr.warning("El tipo de archivos no es valido", "Alerta")
            return null
          }
          console.log("Peso del archivos -->", (file.size /1000000), extension.tamanio_mb)
          if((file.size /1000000) >  extension.tamanio_mb){
            this.toastr.warning("El tamaño del archivo sobrepasa a "+extension.tamanio_mb+"MB", "Alerta")
            return null
          } 
          
          let data = {
            id:0,
            name: file.name,
            type: type,
            size: file.size,
            siglas: tamanio.siglas,
            tamanio: tamanio.numero,
            fecha: file.lastModified,
            estado:1,
            archivo: null
           
          }
          reader.onload = function(e) {
            data.archivo = e.target['result']
          }
          reader.readAsDataURL(file);
          this.archivosAdjuntar.push(data) 
      }
      
    }
    
  }

  public enviar(){
    this.mail.estado = 202
    this.spinner.isSpinnerVisible = true
    this.mail.adjuntos = this.archivosAdjuntar.filter((x:any)=> x.id == 0)
    this.mail.eliminar = this.archivosAdjuntar.filter((x:any)=> x.estado == -99)
    this.correoService.createUpdateMensaje(this.mail).subscribe(
      result=>{
        this.spinner.isSpinnerVisible = false
        this.emittRefrescar.emit()
      }
    )
  }

  public guardar(){
    this.mail.estado = 203
    this.spinner.isSpinnerVisible = true
    this.mail.adjuntos = this.archivosAdjuntar.filter((x:any)=> x.id == 0)
    this.mail.eliminar = this.archivosAdjuntar.filter((x:any)=> x.estado == -99)
    this.correoService.createUpdateMensaje(this.mail).subscribe(
      result=>{
        this.spinner.isSpinnerVisible = false
        this.emittRefrescar.emit()
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/form-envio-mail.component.ts